// React
import React from 'react'
// Components
import Button from '../Display/Button'
import Logo from '../Display/Logo'

export default class Welcome extends React.Component {

	componentDidMount() {
		window.scrollTo(0, 0)
	}

	render() {
		return (
			<div className='capps-container'>
				<Logo {...this.props} />
				<div className='capps-responsive'>
					<div className='capps-height-10' />
					<div className='capps-form'>
						The moon changes signs every 2 to 2.5 days, so you may not need to know your time or place of birth to find your moon sign.
						<div className='capps-height-10' />
						If you don’t know your time of birth, enter a morning time and evening time to see if the sign has changed and which sign seems more accurate. If you don’t know your place of birth, enter a place that’s closest to where you think you might have been born.
					</div>
					<div className='capps-height-10' />
					<Button
						action={() => {
							setTimeout(() => {
								window.localStorage.removeItem('MoonSignApp:timeAndPlace')
								if (this.props.state.nav.length > 1) {
									this.props.redux.nav.removePage()
								}
								else {
									this.props.redux.nav.setPage('')
								}
							}, 20)
						}}
						text='Continue'
					/>
					<div className='capps-height-10' />
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Pages/TimeAndPlace.js